import React from "react";

import Funnel from "./funnel";

const SmartAuditing = () => {
  return (
    <div style={{ height: "100%", display: "flex", alignItems: "center" }}>
      <div>
        <Funnel />
      </div>
    </div>
  );
};
export default SmartAuditing;
